module.exports = __webpack_public_path__ + "static/wedding-putri-5ad109e2abc3c20096b387acfe4de2b1.png";